export default __webpack_public_path__ + "static/media/discord.1821c344.svg";